import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  closeButton: {
    position: "absolute",
    padding: 0,
    top: 15,
    right: 15,
    color: theme.palette.text.primary,
    "& .MuiSvgIcon-root": {
      fontSize: 26
    }
  },
  alert: {
    color: theme.palette.error.main,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  noTitle: {
    paddingTop: 20
  }
}));
